'use client'

import { ArrowRight } from "@phosphor-icons/react";
import LeadForm from "../LeadForm/LeadForm";
import { useState } from "react";

const PageBreak = () => {
  const [showForm, setShowForm] = useState(false);
  return (
    <section className="w-full py-[54px] md:py-[32px] px-[16px] md:px-[80px] bg-[#F7FCFA]">
      <div className="flex flex-col gap-[16px]">
        <div>
          <h3 className="font-[600] text-[38px] md:text-[47px] text-primary leading-[110%]">
            Join ambitious professionals and unlock your dream career today
          </h3>
        </div>
        <div>
          <h4 className="text-[24px] md:text-[21px] font-[400] text-[#414D60] leading-[120%]">
            Unlock your true potential and discover a world of opportunities
            that align with your skills, interests, and aspirations
          </h4>
        </div>
        <div>
          <button className="bg-primary text-white text-[16px] px-[16px] py-[8px] rounded-[4px] flex gap-[8px] uppercase justify-center items-center font-[400] w-full md:w-[250px] h-[50px] cursor-pointer" onClick={() => setShowForm(true)}>
            Join Us
            <span>
              <ArrowRight size={24} />
            </span>
          </button>
        </div>
      </div>
        {showForm && <LeadForm onClose={() => setShowForm(false)} />}
    </section>
  );
};

export default PageBreak;
